export enum NotificationFormMode {
  CREATE = 'create',
  EDIT = 'edit',
  VIEW = 'view',
}

export const isDateValid = (date: Date) => {
  return !Number.isNaN(date.getTime());
};

const TranslationLocal: Record<string, string> = {
  'route.performance.tracking': 'Performance Tracking',
  'route.performance.mdrt': 'MDRT',
  'route.performance.pruelite': 'PRUElite',
  'route.performance.lifeclub': 'LifeClub',
  'route.training.qrcode': 'QR code',
  'route.performance.incentive': 'Incentive',
  'route.sale.pulseleads': 'PRULeads',
  'route.notification': 'Notification',
  'route.feedback': 'Feedback',
  'route.home.calendar': 'Calendar',
  'route.news': 'PRUNews',
  'route.survey': 'Survey',
  'route.sale.promotion': 'Chương trình ưu đãi',
  'route.virtualgp': 'Virtual GP',
  'route.training.pruexpert': 'PRUExpert',
  'route.recruitment.home': 'Recruitment',
  'route.profile': 'Profile',
  'route.sale.enamecard': 'E-name card',
  'route.pulsegeniuses': 'Pulse geniuses',
  'route.sale.planning': 'Sale planning',
  'route.proposal': 'Proposal',
  'route.policy': 'Policy',
  'route.customer.home': 'Customer',
  'route.livestream': 'Livestream',
  'route.setting': 'Settings',
};

export const TranslationAppRoutes = (label: string, Translation: (id: string) => string) => {
  return TranslationLocal[label] ? TranslationLocal[label] : Translation(label);
};
